export function compare(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        var result;
        try {
            result = (a[property].toLowerCase() < b[property].toLowerCase()) ? -1 : (a[property].toLowerCase() > b[property].toLowerCase()) ? 1 : 0;
        } catch (error) {
            result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        }
        return result * sortOrder;
    }
}

// Ordenamiento de grillas: la dirección sale del state de React, no del DOM.
//
// Antes esto era `updateArrows(e)`, que leía `e.target.className` para decidir el próximo sentido
// y lo escribía mutando el DOM a mano. Se rompía siempre: al ordenar, `fetchData` hace
// `setState({loaded:false})` y el render devuelve el loader, con lo que la tabla se DESMONTA;
// al volver a montar, el JSX repone `className="sorting"` en todas las cabeceras y se pierde el
// sentido anterior. El clic siguiente volvía a leer "sorting" y mandaba `asc` de nuevo, así que
// la grilla ordenaba una sola vez y después parecía no responder más.
//
// Con los helpers de abajo la cabecera es función de (sortBy, sortDir) del state: sobrevive al
// remonte y la flecha no puede quedar desincronizada del orden real.

// Clase de la cabecera. `column` es la clave que se manda al backend como `sortBy`.
export function sortClass(column, sortBy, sortDir) {
    if (!column || column !== sortBy) {
        return 'sorting';
    }
    return String(sortDir).toLowerCase() === 'desc' ? 'sorting_desc' : 'sorting_asc';
}

// Próxima dirección al clickear una cabecera: si la columna ya es la ordenada, alterna;
// si es otra, arranca ascendente.
export function nextSortDir(column, sortBy, sortDir) {
    if (column !== sortBy) {
        return 'asc';
    }
    return String(sortDir).toLowerCase() === 'desc' ? 'asc' : 'desc';
}

// `aria-sort` de la cabecera, para que el lector de pantalla diga lo mismo que la flecha.
export function sortAriaSort(column, sortBy, sortDir) {
    if (!column || column !== sortBy) {
        return 'none';
    }
    return String(sortDir).toLowerCase() === 'desc' ? 'descending' : 'ascending';
}